import React from "react";
import { Translation, Translations } from ".";

export const TranslationsContext = React.createContext<Translation>(Translations["en"]);

export const useTranslation = () => {
    const context = React.useContext(TranslationsContext);
    if (!context) {
        throw new Error('useTranslations must be used within TranslationsContext.Provider');
    }
    return context;
};
